import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import { useIsMobile } from '@/utils/useMobile'

import CommonButton from '@/components/form/Button/CommonButton'

import BtnGlobalCustomStyles from '@/components/form/Button/button.customStyles'

import DistanceDropdown from '../DistanceDropdown/DistanceDropdown'

import SortDropdown from '../SortDropdown/SortDropdown'

import {
  FiltersTitle,
  ChoosenFilters,
  ClearAllFiltersWrapper,
  MobileSortContainer
} from './Filters.styled'
import { FiltersContentProps } from './Filters.types'
import FilterOption from './FilterOption'

import Services from './Services/Services'
import MobileFiltersButtons from './MobileFiltersButtons/MobileFiltersButtons'
import { ServicesTitle } from './Services/Services.styled'
import { useServices } from './Services/useServices'
import { ServicesValuesTypes } from './Services/Services.types'

export default function FiltersContent({
  clearAllFilters,
  options,
  removeOption,
  handleAddRemoveService,
  selectedServices,
  handlePriceChangeComplete,
  radius,
  setRadius,
  currency,
  handleOverlayToggle,
  latLon
}: FiltersContentProps) {
  const { t } = useTranslation('parkings')
  const translatedFilterTitle = t('searchNearParking.filters.title')
  const translatedRemoveAllFilters = t(
    'searchNearParking.filters.removeFilters'
  )
  const { isMobile } = useIsMobile()
  const { servicesOptions, additionalFunctionsOptions } = useServices(t)

  const router = useRouter()

  const initialRadius =
    router.query.radius !== undefined
      ? parseInt(router.query.radius as string)
      : null

  const showDistanceFilter = router?.query?.lon && router?.query?.lat

  return (
    <>
      <FiltersTitle data-test-id="filters-title">
        {translatedFilterTitle}
      </FiltersTitle>
      {isMobile && latLon?.[0] && (
        <MobileSortContainer>
          <ServicesTitle>{t('sort')}</ServicesTitle>
          <SortDropdown />
        </MobileSortContainer>
      )}
      <ChoosenFilters data-test-id="chosen-filters">
        {options.map(option => (
          <FilterOption
            key={option.id}
            onClick={removeOption}
            option={option}
            data-test-id={`filter-option-${option.id}`}
          />
        ))}
        {options?.length > 0 && (
          <ClearAllFiltersWrapper>
            <CommonButton
              variant="tileText"
              onClick={clearAllFilters}
              customStyle={BtnGlobalCustomStyles.bookingDetail}
            >
              {translatedRemoveAllFilters}
            </CommonButton>
          </ClearAllFiltersWrapper>
        )}
      </ChoosenFilters>
      <Services
        handleAddRemoveService={handleAddRemoveService}
        selectedServices={selectedServices}
        servicesOptions={servicesOptions}
        title={t('searchNearParking.filters.services')}
      />
      {selectedServices?.includes(ServicesValuesTypes['PARK_AND_FLY']) && (
        <Services
          handleAddRemoveService={handleAddRemoveService}
          selectedServices={selectedServices}
          servicesOptions={additionalFunctionsOptions}
          title={t('searchNearParking.filters.additionalFunctions')}
        />
      )}
      {showDistanceFilter && (
        <DistanceDropdown initialValue={radius} onDistanceChange={setRadius} />
      )}
      {/* // Component is hidden untill Pricing SERVICE implemented */}
      {/* <PriceRange
        min={0}
        max={100}
        onPriceChangeComplete={handlePriceChangeComplete}
        currency={currency}
      /> */}
      {isMobile && (
        <MobileFiltersButtons
          onClearFilters={clearAllFilters}
          onShowResults={handleOverlayToggle}
        />
      )}
    </>
  )
}
